export default "__VITE_ASSET__Cg$k4ktV__";